import { CheckInfoType } from 'adapters/types';
import { CheckNumbersListType } from 'pages/VendorsTablePage/components/PrintChecks/types';

export const useGetCheckNumbersList = (
  checksInfo: CheckInfoType[]
): CheckNumbersListType[] =>
  checksInfo.map(({ checkNumber }) => ({
    checkNumber
  }));
